import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Hub, repeatTemplatesContainerId} from 'yougile-model'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {DivWithHint} from '@components/common/hint/hint'
import {cn} from '@containers/html-utils'
import {Task} from '@extensions/task'
import {useIdTask} from './use-id-tasks'

export const TwLink = tw.a`
  h-14
  max-h-14
  flex
  items-center
  text-action-default
  hover:text-action-hover
  focus:text-action-default
  visited:text-action-default
  text-xxs-semibold
`

interface Props {
  className?: string
  task: Hub
}

export const IdTaskLinkRightPanel = observer((props: Props) => {
  const {task, className} = props
  const idTask = useIdTask(task?.id)

  const isRepeat = task.location === repeatTemplatesContainerId

  if (!task || !idTask || isRepeat) {
    return null
  }

  return (
    <div className={cn('flex items-center justify-start', className)}>
      <DivWithHint content={Lang.context.common.taskLinkCopy}>
        <TwLink
          href={Task.getLink(task)}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault()
            e.stopPropagation()

            if (e.button === 0) {
              Task.copyLink(task)
              void Tracking.send(TrackingEvent.copyTaskLinkRightPanel)
            }
          }}
        >
          {idTask}
        </TwLink>
      </DivWithHint>
    </div>
  )
})
